<template>
    <div class="vue-tooltip" v-click-outside="() => open = false">
        <button @click="open = ! open" class="icon-information">Open tooltip</button>

        <div class="tooltip-content" v-show="open">
            {{ content }}
        </div>
    </div>
</template>

<script>
import vClickOutside from 'v-click-outside';

export default {
    name: "Tooltip",

    directives: {
        clickOutside: vClickOutside.directive
    },

    props: {
        content: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            open: false
        }
    },

    computed: {
        hasContent() {
            return ! _.isEmpty(this.content);
        }
    }
}
</script>